/* RESPONSIBLE TEAM: team-knowledge-foundations */
import ApplicationAdapter from '../application';

export default class DynamicContentAdapter extends ApplicationAdapter {
  pathForType(): string {
    return 'articles/dynamic_contents';
  }
}
